export const fetchProductSettings = async (
  endpoint: string,
  accountId: string,
  productId: string,
  token: string,
): Promise<Record<string, unknown> | null> => {
  const path = `account/products/${accountId}/${productId}`
  try {
    const response = await fetch(`${endpoint}/${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) return null
    const json = await response.json()
    const cfg = json?.config ?? json?.Config ?? json
    return cfg && typeof cfg === 'object' && !Array.isArray(cfg)
      ? (cfg as Record<string, unknown>)
      : null
  } catch {
    return null
  }
}

export const persistProductSettings = async (
  endpoint: string,
  accountId: string,
  productId: string,
  token: string,
  payload: any,
) => {
  const path = `account/products/${accountId}/${productId}`
  const response = await fetch(`${endpoint}/${path}`, {
    method: 'PUT',
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    console.error('Error pushing field mapping configuration.')
    return false
  }

  return true
}
